define('app-console/lib/Trace',['require','exports','module'],function(require,exports,module){
    var lineRx=/.*?(\w+:\/\/.*?\d+:\d+).*/;

	function Trace(ns,err){

		this.stack=(err.stack||'').split('\n');
		this.message=err.message || (ns + 'Error');
        this.file = (this.stack[1]||"").replace(lineRx,"$1");
	}

	Trace.prototype=Object.create(Error.prototype);

	return Trace;
});
